import { CurrencyModel } from "../management/currency.model";

export class CurrencyExchangeModel {
  currencyExchangeId: number = 0;
  companyId: number = 0;
  dateExchange: Date = new Date();
  valueExchange: number = 0;
  currencyId: number = 0;
  currency: CurrencyModel = new CurrencyModel()
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}